import { useScheduler } from '@/contexts/SchedulerContext';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { SchedulerFlow } from './SchedulerFlow';

export function SchedulerModal() {
  const { isOpen, closeScheduler, defaultSlug } = useScheduler();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeScheduler()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto p-0 gap-0 border-border/50 bg-background">
        <DialogTitle className="sr-only">Schedule a Meeting with LINK</DialogTitle>
        <SchedulerFlow defaultSlug={defaultSlug} onComplete={closeScheduler} />
      </DialogContent>
    </Dialog>
  );
}
